<template>
  <div class="pages">

  </div>
</template>

<script>
  import App from '../util/comfun'
  export default {
  data () {
    return {

    }
  },
  created(){
    this.token=this.$route.params.token
    if(this.token && this.token.length>1){
      wxlite.setStorageSync('token',this.token)
      this.lastPage=wxlite.getStorageSync('lastPage')||'/version'
      let hasDebug=this.lastPage.indexOf('--DEBUG--')>-1
      let pathKey
      if(this.lastPage.indexOf('/version')>-1){
        pathKey='version'
      }else if(this.lastPage.indexOf('/buy-traffic')>-1){
        pathKey='buy-traffic'
      }else if(this.lastPage.indexOf('/buy-storage')>-1){
        pathKey='buy-storage'
      }else if(this.lastPage.indexOf('/buy-down-traffic')>-1){
        pathKey='buy-down-traffic'
      }
      let params={}
      params[pathKey]=encodeURIComponent(JSON.stringify({
        token:this.token,
        from:'weixin',
      }))
      let path=App.http_build_query(params,hasDebug?'?--DEBUG--':'?',true)
      let href=location.origin+path
      location.replace(href)
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/token.vue